export default [
  {
    text: "Home",
    path: "/home",
    icon: "home",
  },
  {
    text: "Despatch Order",
    path: "/roam-despatch-order",
    type: "Screen",
    icon: "box",
    applicationFeatureCode: "RoamPicking",
  },
  // {
  //   text: "Bin Movement",
  //   path: "/roam-bin-movement",
  //   type: "Screen",
  //   icon: "decreaseindent",
  //   applicationFeatureCode: "RoamBinMovement",
  // },
  // Products
  {
    text: "Products",
    path: "/roam-product",
    type: "Screen",
    icon: "product",
    applicationFeatureCode: "RoamProduct",
  },
];
